// Entry point for the build script in your package.json

require("@rails/ujs").start()
var $ = require( "jquery" )

require("./chapters")
require("./events")
require("./forms")
require("./journal_entries")
require("./locations")
require("./photos")
require("./registrations")

require("trix")
require("@rails/actiontext")
